/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsRosterJoinResponseDtoSchema = z.object({
  teamId: z.string().nullish(),
  success: z.optional(z.boolean()),
});
